import { environment } from 'src/environments/environment';

export function formatPageTitle(...parts: Array<string | null | undefined>): string {
  const filteredParts = parts
    .map((part) => (part ?? '').trim())
    .filter((part) => part.length > 0);

  return [...filteredParts, environment.appName].join(' | ');
}
